<div class="training-shell">
    @if(page !== TrainingConstants.TRAINING_REQUEST_SUCCESS){
    <div class="training-header">
        <div class="training-header-row">
            <div class="d-flex justify-content-between">
                <h1 class="training-heading">
                    @if(isPartner){
                    {{"training.section.header.partner" | translate}}
                    } @else {
                    {{"homepage.training.header" | translate}}
                    @if(page===TrainingConstants.TRAINING_REQUEST_SUCCESS){
                    - {{'training.header.4'|translate}}
                    }}
                </h1>
                <img (click)="isPartner ? confirmCancelRequest() : openCancelConfirm()" class="confirm-close"
                    src="assets/images/x-blue.svg" alt="{{'training.alt.closeIcon' | translate}}" />
            </div>
            @if(page !== TrainingConstants.TRAINING_REQUEST_SUCCESS && !isPartner){
            <div class="training-stepper" role="progressbar" [attr.aria-valuemin]="1" [attr.aria-valuemax]="4"
                [attr.aria-valuenow]="currentStep">
                @for (s of [1,2,3,4, 5, 6]; track s) {
                <span class="step-pill" [ngClass]="s <= currentStep ? 'active' : ''"></span>
                }
            </div>
            }
        </div>
    </div>
    }

    <div class="training-scroll" #trainingScroll>
        <div class="training-container">
            @switch (page){

            @case (TrainingConstants.TRAINING_CATALOGS){
            @if(isPartner){
            <span class="sub-heading">{{'training.partnerSubheader' | translate}}</span>
              @if(localeService.getLocaleId() === USA_LOCALE_ID) {
                <br/>
                <span class="sub-heading">{{ 'training.digitalCatalog' | translate }}: <a [href]="digitalCatalogUrl" target="_blank">training.compsych.com</a></span>
              }
            }
            @else {
            <h3 class="crc-heading">{{'training.heading.catalog' | translate}}</h3>
            <span class="sub-heading">{{'training.subheader' | translate}}</span>
              @if(localeService.getLocaleId() === USA_LOCALE_ID) {
                <br/>
                <span class="sub-heading">{{ 'training.digitalCatalog' | translate }}: <a [href]="digitalCatalogUrl" target="_blank">training.compsych.com</a></span>
              }
            }
            <div class="pdf-note">
                <img alt="{{'training.alt.pdfIcon' | translate}}" height="16" ngSrc="assets/images/pdf.png" width="16">
                <span>{{'training.pdfNote' | translate}}</span>
            </div>

            <div class="catalog-list">
                @for(node of trainingsNodeList; track $index){
                @if(node.showNode){
                <div class="catalog-card">
                    <div class="catalog-left">

                        <div class="catalog-title">
                            {{
                            (node.displayName || '').includes('(')
                            ? (node.displayName || '').slice(0, (node.displayName || '').indexOf('(')).trim()
                            : (node.displayName || '')
                            }} </div>

                        @if((node.displayName || '')){
                        <div class="catalog-tags">
                            @if(((node.displayName || ''))){
                            <span class="tag-pill tag-lang">
                                {{ (node.displayName.split('(')[1].replace(')','').split(' ')[0] || '') }}
                            </span>

                            <span class="tag-pill tag-region">
                                {{
                                (node.displayName || '').includes('(')
                                ? ((node.displayName.split('(')[1].replace(')','').trim().split(' ').slice(1).join(' '))
                                || '')
                                : ''
                                }}
                            </span>
                            }
                        </div>
                        }
                    </div>

                    <button type="button" class="view-btn" (click)="commonService.viewPDFFile(node.nodeId)">
                        {{'training.button.view' | translate}}
                    </button>
                </div>
                }
                }
            </div>
            }

            @case (TrainingConstants.TRAINING_OVERVIEW){

            <span class="my-3 d-block">
                <h3 class="crc-heading">{{'training.heading.inquiry' | translate}}</h3>
                <span class="d-block sub-heading">{{'training.inquiryIntro' | translate}}</span>

            </span>

            <form [formGroup]="trainingForm" class="crc-form-container">
                @if (errors.length){
                <div class="errors">
                    <div class="error-messages">
                        @for (error of errors;track $index){
                        <li class=""><div style="display:flex"><div class="icon">
                          <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
                        </div> {{error|translate}} {{'training.errors.required'|translate}} </div></li>
                        }
                    </div>
                </div>
                }

                <div class="training-grid">
                    <div class="training-row">
                        <div class="training-label">
                            <label class="crc-input-field-label" for="todaysDate">{{'training.deliveryMethod' |
                                translate}}*</label>
                        </div>
                        <div class="training-input-fields">
                          <div class="select-wrapper">
                            <select id="deliveryMethod"
                                    class="hf-form-input hf-form-select"
                                    formControlName="deliveryMethod"
                                    (change)="selectionChanged('deliveryMethod')"
                                    [class.placeholder-visible]="!trainingForm.get('deliveryMethod')?.value"
                                    [class.has-value]="!!trainingForm.get('deliveryMethod')?.value"
                                    [ngClass]="showError('deliveryMethod') ? 'crc-input-text-error' : ''">
                              <option value="" disabled selected>{{ 'training.selectDeliveryMethod' | translate}}</option>
                              @for (entry of (staticData?.orgEventDeliveryMethodTrns | keyvalue); track entry.key) {
                                <option [value]="entry.value.id">{{ entry.value.description }}</option>
                              }
                            </select>
                            <span class="hf-select-icon" aria-hidden="true">
                              <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                            </span>
                          </div>
                        </div>
                    </div>

                    <div class="training-row">
                        <div class="training-label">
                            <label class="crc-input-field-label" for="interestedIn">{{'training.audience' |
                                translate}}*</label>
                        </div>
                        <div class="training-input-fields">
                          <div class="select-wrapper">
                          <select id="audience" class="hf-form-input hf-form-select"
                                  formControlName="audience"
                                  (change)="selectionChanged('audience')"
                                  [class.placeholder-visible]="!trainingForm.get('audience')?.value"
                                  [class.has-value]="!!trainingForm.get('audience')?.value"
                                  [ngClass]="showError('audience') ? 'crc-input-text-error' : ''">
                            <option value="" disabled>{{'training.chooseACountry' | translate}}</option>
                            @for (audience of (staticData?.audience | keyvalue); track audience.key) {
                              <option [value]="audience.value.id">{{ audience.value.description }}</option>
                            }
                          </select>
                            <span class="hf-select-icon" aria-hidden="true">
                              <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                            </span>
                          </div>
                        </div>
                    </div>

                  <div class="training-row">
                    <div class="training-label">
                      <label class="crc-input-field-label" for="interestedIn">{{'training.language' |
                        translate}}*</label>
                    </div>
                    <div class="training-input-fields">
                      <div class="select-wrapper">
                      <select id="language" class="hf-form-input hf-form-select"
                              formControlName="language"
                              (change)="selectionChanged('language')"
                              [class.placeholder-visible]="!trainingForm.get('language')?.value"
                              [class.has-value]="!!trainingForm.get('language')?.value"
                              [ngClass]="showError('language') ? 'crc-input-text-error' : ''">
                        <option value="" disabled>{{'training.selectYourLanguage' | translate}}</option>
                        @for (language of sortedLanguages; track language.id) {
                          <option [value]="language.id">{{ language.description }}</option>
                        }
                      </select>
                        <span class="hf-select-icon" aria-hidden="true">
                          <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                        </span>
                      </div>
                    </div>
                  </div>

                  @if (hasDialectsForSelectedLanguage) {
                    <div class="unique-row">
                      <div class="stick"></div>
                      <div class="training-row">
                        <div class="training-label">
                          <label class="crc-input-field-label" for="dialect">
                            {{ 'training.dialect' | translate }}*
                          </label>
                        </div>
                        <div class="training-input-fields">
                          <div class="select-wrapper">
                            <select
                              id="dialect"
                              class="hf-form-input hf-form-select"
                              formControlName="dialect"
                              [class.placeholder-visible]="!trainingForm.get('dialect')?.value"
                              [class.has-value]="!!trainingForm.get('dialect')?.value"
                              [ngClass]="showError('dialect') ? 'crc-input-text-error' : ''">
                              <option value="" disabled>{{'training.selectYourDialect' | translate}}</option>
                              @for (dialect of filteredDialects; track dialect.dialectId) {
                                <option [value]="dialect.dialectId">
                                  {{ dialect.dialectName }}
                                </option>
                              }
                            </select>
                            <span class="hf-select-icon" aria-hidden="true">
                              <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if(showEventLocation) {

                    <span class="d-block fw-bold">{{'training.eventLocation' | translate}}</span>

                  <div class="section-heading-line"></div>

                  <div class="training-row">
                    <div class="training-label">
                      <label class="crc-input-field-label" for="interestedIn">{{'training.country' |
                        translate}}*</label>
                    </div>
                    <div class="training-input-fields">
                      <div class="select-wrapper">
                        <select id="country" class="hf-form-input hf-form-select"
                                formControlName="country"
                                (change)="selectionChanged('country')"
                                [class.placeholder-visible]="!trainingForm.get('country')?.value"
                                [class.has-value]="!!trainingForm.get('country')?.value"
                                [ngClass]="showError('country') ? 'crc-input-text-error' : ''">
                          <option value="" disabled>{{'training.chooseACountry' | translate}}</option>
                          @for (country of sortedCountries; track country.id) {
                            <option [value]="country.id">{{ country.description }}</option>
                          }
                        </select>
                        <span class="hf-select-icon" aria-hidden="true">
                          <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="split-div">
                    <div class="training-row">
                      <div class="training-label">
                        <label class="crc-input-field-label" for="interestedIn">{{'training.zipcode' |
                          translate}}
                          @if(trainingForm.get('country')?.value == UNITED_STATES_ID || trainingForm.get('country')?.value == CANADA_ID) {
                            *
                          }
                        </label>
                      </div>
                      <div class="training-input-fields">
                            <input class="hf-form-input" style="height: 48px !important;" formControlName="zipcode"
                                      id="participants" [ngClass]="showError('zipcode') ? 'crc-input-text-error' : ''">
                      </div>
                    </div>

                    <div class="training-row">
                      <div class="training-label">
                        <label class="crc-input-field-label" for="interestedIn">{{'training.state' |
                          translate}}
                          @if(trainingForm.get('country')?.value == UNITED_STATES_ID || trainingForm.get('country')?.value == CANADA_ID) {
                            *
                          }
                        </label>
                      </div>
                      <div class="training-input-fields">
                        <div class="select-wrapper">
                          <select id="stateSelection"
                                  class="hf-form-input hf-form-select"
                                  formControlName="state"
                                  (change)="selectionChanged('state')"
                                  [class.placeholder-visible]="!trainingForm.get('state')?.value"
                                  [class.has-value]="!!trainingForm.get('state')?.value"
                                  [ngClass]="showError('state') ? 'crc-input-text-error' : ''">

                            @if (statePlaceholderMode === 'no-state') {
                              <option [ngValue]="null" disabled>
                                {{ 'training.noStateAvailable' | translate }}
                              </option>
                            } @else if (statePlaceholderMode === 'select') {
                              <option [ngValue]="null" disabled>
                                {{ 'training.select' | translate }}
                              </option>

                              @for (state of filteredStates; track state.stateId) {
                                <option [ngValue]="state.stateId">{{ state.stateName }}</option>
                              }
                            } @else {
                              <option [ngValue]="null" disabled hidden></option>
                            }
                          </select>
                          <span class="hf-select-icon" aria-hidden="true">
                            <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                    <div class="training-row">
                        <div class="training-label">
                            <label class="crc-input-field-label" for="participants">{{'training.city' |
                                translate}}*</label>
                        </div>
                        <div class="training-input-fields">
                            <input class="hf-form-input" style="width: 100% !important; resize: none" formControlName="city"
                                   [ngClass]="showError('city') ? 'crc-input-text-error' : ''"
                                id="city">
                        </div>
                    </div>

                  <div class="training-row">
                    <div class="training-label">
                      <label class="crc-input-field-label" for="participants">{{'training.address1' |
                        translate}}*</label>
                    </div>
                    <div class="training-input-fields">
                            <input class="hf-form-input" style="width: 100% !important; resize: none" formControlName="address1" [ngClass]="showError('address1') ? 'crc-input-text-error' : ''"
                                      id="address1">
                    </div>
                  </div>

                  <div class="training-row">
                    <div class="training-label">
                      <label class="crc-input-field-label" for="participants">{{'training.address2' |
                        translate}} {{'training.optional' | translate}}</label>
                    </div>
                    <div class="training-input-fields">
                            <input class="hf-form-input" style="width: 100% !important; resize: none" formControlName="address2"
                                      id="address2" [ngClass]="showError('address2') ? 'crc-input-text-error' : ''">
                    </div>
                  </div>
                  }
                </div>

            </form>
            }

              @case (TrainingConstants.TRAINING_SESSION_INFORMATION){

            <form [formGroup]="trainingForm" class="crc-form-container">
                @if (errors.length){
                <div class="errors">
                    <div class="icon">
                        <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
                    </div>
                    <div class="error-messages">
                        @for (error of errors;track $index){
                        <li class="">{{error}} {{'training.errors.required'|translate}}</li>
                        }
                    </div>
                </div>
                }

                <div class="training-grid">

                    <div class="training-row">
                        <div class="training-label">
                            <label class="crc-input-field-label" for="organization">{{'training.account' |
                                translate}}</label>
                        </div>
                      <div class="training-input-fields">
                        <div class="select-wrapper">
                        <select id="account" class="hf-form-input hf-form-select"
                                formControlName="account"
                                (change)="selectionChanged('account')"
                                [class.placeholder-visible]="!trainingForm.get('account')?.value"
                                [class.has-value]="!!trainingForm.get('account')?.value">
                          @for (opt of accountOrgOptions; track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                          }
                        </select>
                          <span class="hf-select-icon" aria-hidden="true">
                            <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="training-row">
                      <div class="add-section-div">
                      <div class="session-info-title">{{ 'training.sessionInfo' | translate }}</div>
                        @if(sessions.length < 3) {
                          <button type="button" (click)="addSession()" class="add-session-btn">{{ 'training.addSession' | translate }}</button>
                        }
                      </div>
                    </div>

                  <div formArrayName="sessions">
                    @if (sessions.length > 0) {
                      @for (sessionGroup of sessions.controls; track $index) {
                          <div class="training-row" [formGroup]="sessionGroup" [ngClass]="{ 'margin-top-32': $index !== 0 }">
                          <div class="training-grid">

                            <div class="training-row">
                              <div class="session-details">
                                <div class="session-title">
                                  {{ 'training.session' | translate }} {{ $index + 1 }}
                                </div>
                            @if(sessions.length > 1) {
                              <img
                                class="trash-icon"
                                alt=""
                                src="assets/images/trash.svg"
                                (click)="removeSession($index)"
                              />
                            }
                              </div>
                            </div>

                            <div class="section-divide"></div>

                            <div class="training-row">
                              <div class="training-label">
                                <label class="crc-input-field-label">
                                  {{ 'training.title' | translate }}*
                                </label>
                              </div>

                              <div class="training-input-fields">
                                <div class="select-wrapper">
                                  <select
                                    class="hf-form-input hf-form-select"
                                    formControlName="title"
                                    (change)="onTitleChanged($index)"
                                    [class.placeholder-visible]="!sessionGroup.get('title')?.value"
                                    [class.has-value]="!!sessionGroup.get('title')?.value"
                                    [ngClass]="showError('title', sessionGroup) ? 'crc-input-text-error' : ''"
                                  >
                                    <option value="" disabled>{{'training.selectYourTraining' | translate}}</option>
                                    @for (title of filteredTitles; track title.titleId) {
                                      <option [value]="title.titleId">{{ title.titleName }}</option>
                                    }
                                  </select>
                                  <span class="hf-select-icon" aria-hidden="true">
                                    <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                                  </span>
                                </div>
                              </div>

                              @if (isFutureAvailableFrom(getSelectedTitleAvailableFrom(sessionGroup))) {
                                <div class="available-from-info">
                                  {{ 'training.titleAvailableFrom' | translate: { date: formatAvailableFromDate(getSelectedTitleAvailableFrom(sessionGroup)) } }}
                                </div>
                              }
                            </div>

                            @if(showEstimatedNumberOfAttendees) {
                            <div class="training-row">
                              <div class="training-label">
                                <label class="crc-input-field-label">
                                  {{ 'training.estimatedNumberOfAttendees' | translate }}*
                                </label>
                              </div>

                              <div class="training-input-fields">
                                <div class="training-input-fields">
                                  <input
                                    class="hf-form-input noOfAttendesTxt"
                                    formControlName="numberOfAttendees"
                                    id="estimatedNumberOfAttendees"
                                    [ngClass]="showError('numberOfAttendees', sessionGroup) ? 'crc-input-text-error' : ''"
                                  />
                                </div>
                              </div>

                              @if(sessions.at($index).get('numberOfAttendees')?.errors?.['nonZero']) {
                                <span style="color: red">{{ 'training.numberMustBeGreaterThanZero' | translate }}</span>
                              }

                            </div>
                            }

                            <div class="training-row">
                              <div class="training-label">
                                <label class="crc-input-field-label">
                                  {{ 'training.eventDate' | translate }}*
                                </label>
                              </div>

                              <mat-form-field appearance="outline" class="datePickerInput">
                                <input
                                  matInput
                                  formControlName="eventDate"
                                  [min]="minEventDate"
                                  id="eventDateInput"
                                  class="hf-form-input"
                                  readonly
                                  [matDatepicker]="eventDatePicker"
                                  (click)="eventDatePicker.open()"
                                  (dateChange)="onEventDateChanged($index)"
                                  placeholder="{{'training.selectADate' | translate}}"
                                />

                                <button
                                  mat-icon-button
                                  matPrefix
                                  type="button"
                                  class="btn-picker"
                                  (click)="eventDatePicker.open()"
                                  aria-label="Open calendar"
                                >
                                  <img style="width: 16px; height: 16px" src="assets/images/calendar.svg" alt="calendar" />
                                </button>

                                <mat-datepicker #eventDatePicker panelClass="hide-month-label-datepicker"></mat-datepicker>
                              </mat-form-field>

                              @if(trainingForm.get('eventDate')?.touched && trainingForm.get('eventDate')?.hasError('minDateAfterDays')) {
                              <div class="event-date-text">
                                {{ 'training.eventDateMustBeInFuture' | translate }}
                              </div>
                              }

                              @if(sessionGroup.get('eventDate')?.touched && sessionGroup.get('eventDate')?.hasError('availableFrom')) {
                                <div class="event-date-error">
                                  {{ 'training.eventDateBeforeAvailableFrom' | translate: { date: formatAvailableFromDate(sessionGroup.get('eventDate')?.getError('availableFrom')?.date) } }}
                                </div>
                              }

                              @if(sessionCppAvailableFromDates[$index]) {
                                <div class="event-date-error">
                                  {{ 'training.eventDateBeforeAvailableFrom' | translate: { date: sessionCppAvailableFromDates[$index] } }}
                                </div>
                              }

                              <div class="event-date-text">{{ 'training.datePickerNote' | translate }}</div>
                            </div>

                            @if(showTimeZone) {
                              <div class="training-row">
                                <div class="training-label">
                                  <label class="crc-input-field-label">
                                    {{ 'training.timeZone' | translate }}*
                                  </label>
                                </div>

                                <div class="training-input-fields" style="width: 195.5px;">
                                  <app-searchable-timezone-dropdown
                                    formControlName="timeZone"
                                    [zones]="sortedTimeZones"
                                    [placeholder]="'training.selectYourTimeZone' | translate"
                                    [hasError]="showError('timeZone', sessionGroup)"
                                  ></app-searchable-timezone-dropdown>
                                </div>
                              </div>
                            }

                            <div class="training-row">
                              <div class="training-label">
                                <label class="crc-input-field-label">
                                  {{ 'training.startTime' | translate }}*
                                </label>
                              </div>

                              <div class="training-input-fields start-time-component">

                                <div class="select-wrapper start-time-component-box">
                                  <select
                                    class="hf-form-input hf-form-select"
                                    formControlName="startTimeHour"
                                    [class.placeholder-visible]="!sessionGroup.get('startTimeHour')?.value"
                                    [class.has-value]="!!sessionGroup.get('startTimeHour')?.value"
                                    [ngClass]="(sessionGroup.get('startTimeHour')?.touched && sessionGroup.get('startTimeHour')?.errors) ? 'crc-input-text-error' : ''"
                                  >
                                    <option value="" disabled>09</option>
                                    @for (h of timeHours; track h) {
                                      <option [value]="h">{{ h }}</option>
                                    }
                                  </select>
                                  <span class="hf-select-icon" aria-hidden="true">
                                    <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                                  </span>
                                </div>

                                <span class="start-time-component-colon">:</span>

                                <div class="select-wrapper start-time-component-box">
                                  <select
                                    class="hf-form-input hf-form-select"
                                    formControlName="startTimeMinute"
                                    [class.placeholder-visible]="!sessionGroup.get('startTimeMinute')?.value"
                                    [class.has-value]="!!sessionGroup.get('startTimeMinute')?.value"
                                    [ngClass]="(sessionGroup.get('startTimeMinute')?.touched && sessionGroup.get('startTimeMinute')?.errors) ? 'crc-input-text-error' : ''"
                                  >
                                    <option value="" disabled>00</option>
                                    @for (m of timeMinutes; track m) {
                                      <option [value]="m">{{ m }}</option>
                                    }
                                  </select>
                                  <span class="hf-select-icon" aria-hidden="true">
                                    <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                                  </span>
                                </div>

                                <div class="select-wrapper start-time-component-box-lg">
                                  <select
                                    class="hf-form-input hf-form-select"
                                    formControlName="startTimePeriod"
                                    [class.placeholder-visible]="!sessionGroup.get('startTimePeriod')?.value"
                                    [class.has-value]="!!sessionGroup.get('startTimePeriod')?.value"
                                    [ngClass]="(sessionGroup.get('startTimePeriod')?.touched && sessionGroup.get('startTimePeriod')?.errors) ? 'crc-input-text-error' : ''"
                                  >
                                    <option value="" disabled>AM</option>
                                    @for (p of timePeriods; track p) {
                                      <option [value]="p">{{ p }}</option>
                                    }
                                  </select>
                                  <span class="hf-select-icon" aria-hidden="true">
                                    <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                                  </span>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      }
                    }
                  </div>

                </div>
            </form>
            }

            @case (TrainingConstants.TRAINING_CONTACT_INFORMATION){
              <form [formGroup]="trainingForm" class="crc-form-container">
                @if (errors.length || contactConfEmailError){
                  <div class="errors">
                    <div class="icon">
                      <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Error" />
                    </div>
                    <div class="error-messages">
                      @for (error of errors;track $index){
                        <li class="">{{error|translate}} {{'training.errors.required'|translate}}</li>
                      }
                      @if (contactConfEmailError) {
                        <li class="">{{'training.errors.atLeastOneConfEmail' | translate}}</li>
                      }
                    </div>
                  </div>
                }

                <div class="training-grid">
                <div class="training-row">
                  <div class="add-section-div">
                    <div class="session-info-title">{{ 'training.contactInfo' | translate }}</div>
                    @if(contacts.length < 4) {
                      <button type="button" (click)="addContact()" class="add-session-btn">{{ 'training.addContact' | translate }}</button>
                    }
                  </div>
                </div>

                  <div formArrayName="contacts">
                @if(contacts.length > 0) {
                  @for (contactGroup of contacts.controls; track $index) {
                    <div class="training-row" [formGroup]="contactGroup" [ngClass]="{ 'margin-top-32': $index !== 0 }">
                      <div class="training-grid">
                      <div class="training-row">
                        <div class="session-details">
                          <div class="session-title">
                            @if($index == 0) {
                              {{ 'training.primaryContact' | translate }}
                            } @else {
                              {{ 'training.additionalContact' | translate }}
                            }
                          </div>
                          @if(contacts.length > 1) {
                            <img class="trash-icon" alt="" src="assets/images/trash.svg" (click)="removeContact($index)" />
                          }
                        </div>
                      </div>
                      <div class="section-divide"></div>

                        @if(Number(trainingForm.get('deliveryMethod')?.value) === DELIVERY_METHOD_ON_SITE) {
                          <div class="training-row">
                            <div class="training-label">
                              <label class="crc-input-field-label" for="contactType">{{'training.contactType' |
                                translate}}*</label>
                            </div>

                            <div class="training-input-fields">
                              <div class="select-wrapper">
                                <select id="contactTypeCodeId" class="hf-form-input hf-form-select"
                                        formControlName="contactTypeCodeId"
                                        (change)="selectionChanged('contactTypeCodeId', contactGroup)"
                                        [class.placeholder-visible]="!contactGroup.get('contactTypeCodeId')?.value"
                                        [class.has-value]="!!contactGroup.get('contactTypeCodeId')?.value"
                                        [ngClass]="showError('contactTypeCodeId', contactGroup) ? 'crc-input-text-error' : ''">
                                  <option value="" disabled selected>Select your contact type</option>
                                  @for (contactType of (staticData?.contactTypes | keyvalue); track contactType.key) {
                                    <option [value]="contactType.value.id">{{ contactType.value.description }}</option>
                                  }
                                </select>
                                <span class="hf-select-icon" aria-hidden="true">
                              <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                            </span>
                              </div>
                            </div>
                          </div>
                        }

                      <div class="split-div">
                        <div class="training-row">
                          <div class="training-label">
                            <label class="crc-input-field-label" for="contactName">{{'training.firstName' |
                              translate}}*</label>
                          </div>

                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="hf-form-input name-fields" formControlName="firstName" [ngClass]="showError('firstName', contactGroup) ? 'crc-input-text-error' : ''"
                                      id="firstName">
                            </div>
                          </div>
                        </div>

                        <div class="training-row">

                          <div class="training-label">
                            <label class="crc-input-field-label" for="contactName">{{'training.lastName' |
                              translate}}*</label>
                          </div>

                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="hf-form-input name-fields" formControlName="lastName" [ngClass]="showError('lastName', contactGroup) ? 'crc-input-text-error' : ''"
                                      id="lastName">
                            </div>
                          </div>
                        </div>
                        </div>

                      <div class="training-row">
                        <div class="training-label">
                          <label class="crc-input-field-label" for="title">{{'training.title' |
                            translate}} {{ 'training.optional' | translate }}</label>
                        </div>
                        <div class="training-input-fields">
                          <div class="training-input-fields">
                            <input class="hf-form-input title-field" formControlName="contactTitle"
                                      id="title">
                          </div>
                        </div>
                      </div>

                      <div class="training-row">
                        <div class="training-label">
                          <label class="crc-input-field-label" for="title">{{'training.email' |
                            translate}}*</label>
                        </div>
                        <div class="training-input-fields">
                          <div class="training-input-fields">
                            <input class="hf-form-input title-field" formControlName="email" [ngClass]="showError('email', contactGroup) ? 'crc-input-text-error' : ''"
                                      id="email">
                          </div>
                        </div>

                        @if(contacts.at($index).get('email')?.errors?.['email']) {
                            Email is invalid
                        }

                      </div>

                      <div class="training-row">
                        <div class="training-label">
                          <label class="crc-input-field-label" for="title">{{'training.phoneNumber' |
                            translate}}
                            @if(phoneNumberRequired) {
                              *
                            } @else {
                              {{ 'training.optional' | translate }}
                            }
                            </label>

                        </div>

                        <div class="phone-number-grid">
                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="phone-code-textbox" formControlName="phoneNumberCountryCode"
                                      id="phoneNumberCountryCode">
                            </div>
                          </div>

                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="phone-code-textbox" placeholder="(555)" formControlName="phoneNumberAreaCode"
                                      id="phoneNumberAreaCode" [ngClass]="showError('phoneNumberAreaCode', contactGroup) ? 'crc-input-text-error' : ''">
                            </div>
                          </div>

                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="phone-number-textbox" formControlName="phoneNumber"
                                      id="phoneNumber" [ngClass]="showError('phoneNumber', contactGroup) ? 'crc-input-text-error' : ''">
                            </div>
                          </div>

                          <div class="training-input-fields">
                            <div class="training-input-fields">
                            <input class="phone-code-textbox" placeholder="Ext." formControlName="phoneNumberExt"
                                      id="phoneNumberExt">
                            </div>
                          </div>

                        </div>
                        @if (
                          contacts.at($index).get('phoneNumber')?.errors?.['phoneNumberMinDigits'] &&
                          contacts.at($index).get('phoneNumber')?.touched
                          ) {
                          <div style="margin-top: 2px">
                            <span style="color: red">{{ 'training.phoneNumberIsInvalid' | translate }}</span>
                          </div>
                        }

                        @if (contactGroup.get('phoneNumberAreaCode')?.touched && contactGroup.get('phoneNumberAreaCode')?.errors?.['phoneNumberAreaCodeExactDigits']) {
                          <div style="margin-top: 2px">
                            <span style="color: red">{{ 'training.areaCodeError' | translate }}</span>
                          </div>
                        }
                      </div>

                      <div class="training-row">
                        <div class="training-label">
                          <label class="crc-input-field-label" for="title">{{'training.includeInConfirmationEmail' |
                            translate}}</label>
                        </div>

                        <div class="training-input-fields">
                          <div class="select-wrapper" style="width: 195.5px!important;">
                          <select id="includeInAccConfEmailInd" class="hf-form-input hf-form-select"
                                  formControlName="includeInAccConfEmailInd"
                                  (change)="selectionChanged('includeInAccConfEmailInd')">
                            <option [ngValue]=true>{{'training.yes' | translate}}</option>
                            <option [ngValue]=false>{{'training.no' | translate}}</option>
                          </select>
                            <span class="hf-select-icon" aria-hidden="true">
                              <img src="assets/images/chevron-down.svg" alt="dropdown-arrow"/>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  }
                }
                </div>
                </div>
              </form>
            }

              @case (TrainingConstants.TRAINING_ADDITIONAL_INFORMATION){
                <form [formGroup]="trainingForm" class="crc-form-container">
                  <div class="training-grid">
                    <div class="training-row">
                      <div class="training-label">
                        <label class="crc-input-field-label" for="title">{{'training.additionalInformation' |
                          translate}}</label>
                      </div>
                      <div class="training-input-fields">
                        <div class="training-input-fields">
                            <textarea class="hf-form-input additional-info-text-area" formControlName="additionalInformation" maxlength="500"
                                      id="additionalInformation"></textarea>
                        </div>
                      </div>
                      <div class="word-count">
                        {{ additionalInformationLength }} / 500 {{'characters' | translate}}
                      </div>
                    </div>
                  </div>
                </form>
              }

            @case (TrainingConstants.TRAINING_REVIEW){

            <h3 class="crc-heading">{{'training.confirm.title' | translate}}</h3>

            <div class="sub-heading review-subheading">
                {{'training.confirm.note' | translate}}
            </div>

            <div class="review-list">

                <div class="review-item">
                    <div class="review-label">{{'training.deliveryMethod' | translate}}</div>
                    <div class="review-value">{{staticData.orgEventDeliveryMethodTrns[trainingData.deliveryMethod].description}}</div>
                </div>

                <div class="review-item">
                    <div class="review-label">{{'training.audience' | translate}}</div>
                    <div class="review-value">{{ staticData.audience[trainingData.audience].description }}</div>
                </div>

              <div class="review-item">
                <div class="review-label">{{'training.language' | translate}}</div>
                <div class="review-value">{{ staticData.languages[trainingData.language].description }}</div>
              </div>

              @if(trainingData.dialect) {
                <div class="review-item">
                  <div class="review-label">{{'training.dialect' | translate}}</div>
                  <div class="review-value">{{ staticData.dialects[trainingData.dialect].dialectName}}</div>
                </div>
              }

              @if(trainingData.deliveryMethod == DELIVERY_METHOD_ON_SITE) {
                <div class="review-section">{{'training.eventLocation' | translate}}</div>

                <div class="review-item">
                    <div class="review-label">{{'training.address1' | translate}}*</div>
                    <div class="review-value">{{trainingData.address.address1}}
                    </div>
                </div>

                @if(trainingData.address.address2) {
                  <div class="review-item">
                    <div class="review-label">{{'training.address2' | translate}} {{'training.optional' | translate}}</div>
                    <div class="review-value">{{trainingData.address.address2 || ('training.notProvided' | translate)}}
                    </div>
                  </div>
                }

                <div class="review-item">
                    <div class="review-label">{{'training.city' | translate}}*</div>
                    <div class="review-value">{{trainingData.address.city}}
                    </div>
                </div>


                @if(trainingData.address.stateProvinceId) {
                  <div class="review-item">
                    <div class="review-label">{{'training.state' | translate}}</div>
                    <div class="review-value">{{ statesById[trainingData.address.stateProvinceId]?.stateName }}</div>
                  </div>
                }


                @if(trainingData.address.zip) {
                  <div class="review-item">
                    <div class="review-label">{{'training.zipcode' | translate}}*</div>
                    <div class="review-value">{{trainingData.address.zip}}</div>
                  </div>
                }

                <div class="review-item">
                    <div class="review-label">{{'training.country' | translate}}</div>
                    <div class="review-value">{{staticData.countries[trainingData.country].description}}</div>
                </div>

            }

              @if(trainingData.sessions.length > 0) {
                <div class="review-section">{{'training.sessionInfo' | translate}}</div>

                <div class="review-item">
                  <div class="review-label">{{'training.account' | translate}}*</div>
                  <div class="review-value">{{ trainingData.selectedAccount }}</div>
                </div>

                @for(session of trainingData.sessions; track $index){
                  <div class="review-section">{{ 'training.session' | translate }} {{ $index + 1 }}</div>

                  <div class="review-item">
                    <div class="review-label">{{'training.account' | translate}}*</div>
                    <div class="review-value">{{ trainingData.selectedAccount }}</div>
                  </div>

                  <div class="review-item">
                    <div class="review-label">{{'training.title' | translate}}*</div>
                    <div class="review-value">{{ staticData.accountEventTitles[session.trnEventTitleId].titleName }}</div>
                  </div>

                  @if(session.attendeesEstimate) {
                    <div class="review-item">
                      <div class="review-label">{{'training.estimatedNumberOfAttendees' | translate}}</div>
                      <div class="review-value">{{session.attendeesEstimate}}</div>
                    </div>
                  }

                  <div class="review-item">
                    <div class="review-label">{{'training.eventDate' | translate}}*</div>
                    <div class="review-value">{{session.eventDate}}</div>
                  </div>

                  @if(session.trnTimezoneId) {
                    <div class="review-item">
                      <div class="review-label">{{'training.timeZone' | translate}}*</div>
                      <div class="review-value">{{staticData.timeZones[Number(session.trnTimezoneId)].description}}</div>
                    </div>
                  }

                  <div class="review-item">
                    <div class="review-label">{{'training.startTime' | translate}}*</div>
                    <div class="review-value">{{getConvertedTime(session.startDatetime)}}</div>
                  </div>
                }
              }

              @if(trainingData.contacts.length > 0) {
                <div class="review-section">{{'training.contactInfo' | translate}}</div>
                @for(contact of trainingData.contacts; track $index){
                  @if($index == 0) {
                    <div class="review-section">{{'training.primaryContact' | translate}}</div>
                  } @else {
                    <div class="review-section">{{'training.additionalContact' | translate}} {{ $index }}</div>
                  }

                  @if(Number(trainingForm.get('deliveryMethod')?.value) === DELIVERY_METHOD_ON_SITE) {
                    <div class="review-item">
                      <div class="review-label">{{'training.contactType' | translate}}*</div>
                      <div class="review-value">{{staticData.contactTypes[Number(contact.contactTypeCodeId)]?.description}}</div>
                    </div>
                  }

                  @if(contact.firstName) {
                    <div class="review-item">
                      <div class="review-label">{{'training.firstName' | translate}}*</div>
                      <div class="review-value">{{contact.firstName}}</div>
                    </div>
                  }

                  @if(contact.lastName){
                    <div class="review-item">
                      <div class="review-label">{{'training.lastName' | translate}}*</div>
                      <div class="review-value">{{contact.lastName}}</div>
                    </div>
                  }

                  @if(contact.contactTitle) {
                    <div class="review-item">
                      <div class="review-label">{{'training.title' | translate}} {{'training.optional' | translate}}</div>
                      <div class="review-value">{{contact.contactTitle}}</div>
                    </div>
                  }

                  @if(contact.phones?.[0]?.phoneNumber) {
                    <div class="review-item">
                      <div class="review-label">{{'training.phoneNumber' | translate}}</div>
                      <div class="review-value">{{contact.phones[0].countryCode}} {{contact.phones[0].areaCode}} {{contact.phones[0].phoneNumber}} {{contact.phones[0].extension}}</div>
                    </div>
                  }

                  @if(contact.emailAddress) {
                    <div class="review-item">
                      <div class="review-label">{{'training.email' | translate}}*</div>
                      <div class="review-value">{{contact.emailAddress}}</div>
                    </div>
                  }

                  <div class="review-item">
                    <div class="review-label">{{ 'training.includeInConfirmationEmail' | translate }}*</div>
                    <div class="review-value">
                      {{ contact.includeInAccConfEmailInd ? ('training.yes' | translate) : ('training.no' | translate) }}
                    </div>
                  </div>
                }
              }


              @if(trainingData.additionalInformation) {
                <div class="review-item">
                  <div class="review-label">{{'training.additionalInformation' | translate}}</div>
                  <div class="review-value">{{trainingData.additionalInformation}}</div>
                </div>
              }

            </div>
            }

            @case (TrainingConstants.TRAINING_REQUEST_SUCCESS){
                <img (click)="confirmCancelRequest()" class="confirm-close"
                    src="assets/images/x-blue.svg" alt="{{'training.alt.closeIcon' | translate}}" />

            <div class="success-center">
                <img class="success-check" src="assets/images/checkbox.svg" />

                <div class="success-copy">
                    <div class="success-title">{{'training.success.title' | translate}}</div>
                    <div class="success-subtitle">{{'training.success.subtitle' | translate}}</div>
                </div>
            </div>
            }
            }
        </div>
    </div>

    @if(!isPartner){
    @if(page!==TrainingConstants.TRAINING_REQUEST_SUCCESS){
    <div class="training-buttons-container">
        @if(showBack){
        <input (click)="navigateToPreviousPage(page)" [value]="'general.label.button.back'|translate" class="crc-button" [disabled]="loading"
            type="button">
        } @else {
        <input (click)="openCancelConfirm()" [value]="'general.label.button.cancel'|translate" class="crc-button"
            type="button">

        }
      <button class="crc-button" type="submit" (click)="submitTrainingRequest(page)" [disabled]="loading">
        @if (loading) {
          <img class="login-loading-gif spinner" src="assets/images/loading_new.gif" alt="Loading"/>
        } @else {
          {{ nextButtonKey | translate }}
        }
      </button>

    </div>
    } @else {
    <div class="training-buttons-container success-footer">
        <button type="button" class="crc-button" (click)="confirmCancelRequest()">
            {{'training.button.close' | translate}}
        </button>

        <button type="button" class="crc-button" (click)="resetTrainingRequest()">
            {{'training.button.submitAnother' | translate}}
        </button>
    </div>
    }
    } @else {
    <div class="training-buttons-container success-footer">
        <button type="button" class="crc-button" (click)="confirmCancelRequest()">
            {{'training.button.close' | translate}}
        </button>
    </div>
    }

</div>
@if (showCancelConfirm) {
<div class="confirm-overlay" (click)="closeCancelConfirm()">
    <div class="confirm-sheet" (click)="$event.stopPropagation()">

        <div class="confirm-close-row">
            <img (click)="closeCancelConfirm()" class="confirm-close" src="assets/images/x-blue.svg"
                alt="{{'training.alt.closeIcon' | translate}}" />
        </div>

        <div class="confirm-body">
            <img class="confirm-icon" src="assets/images/alert-triangle.svg" alt="">

            <div class="confirm-copy">
                <div class="confirm-title">{{ 'healthFair.cancelConfirm.title' | translate }}</div>
                <div class="confirm-subtitle">
                    {{ 'healthFair.cancelConfirm.subtitle' | translate }}
                </div>
            </div>
        </div>
        <div class="confirm-actions">
            <button class="confirm-primary" type="button" (click)="closeCancelConfirm()">
                <span>{{ 'healthFair.cancelConfirm.continue' | translate }}</span>
            </button>

            <button class="confirm-secondary" type="button" (click)="confirmCancelRequest()">
                <span>{{ 'healthFair.cancelConfirm.cancel' | translate }}</span>
            </button>
        </div>
    </div>
</div>

}
